import axios from 'axios'
import { get } from './base'

const getAppsSource = axios.CancelToken.source()

const appsEndpoint = '/api/v2/apps'

export function getApps() {
  return get(appsEndpoint, {
    cancelToken: getAppsSource.token,
  })
}
